import { ServiceOrderStatusEnum } from "../Services/api/service-orders/service-order.interface";




export const labelsOrderProductionStatus : Record<ServiceOrderStatusEnum, string> = {
    ERROR: 'Erro',
    INITIAL: 'Inicial',
    PROCESSING: 'Processamento',
    
    ON_GOING: 'Em andamento',
    PRODUCTION: 'Em produção',
    DELAYED: 'Atrasado',
    PRODUCED: 'Produzido',
    HALF_BILLED: 'Parcialmente faturado',
    BILLED: 'Faturado',
};



export const normalizeOrderProductionStatus = (status: ServiceOrderStatusEnum): { bgColor: string; textColor: string } => {
    const bgColor: Record<ServiceOrderStatusEnum, string> = {
        ERROR: 'rgba(255, 193, 7, 0.7)', // Amarelo
        INITIAL: 'rgba(0, 150, 136, 0.7)', // Verde Água
        PROCESSING: 'rgba(103, 58, 183, 0.7)', // Amarelo
        ON_GOING: 'rgba(128, 0, 128, 0.7)', // Roxo
        PRODUCTION: 'rgba(9, 86, 24, 0.7)', // Verde Água
        DELAYED: 'rgba(128, 0, 128, 0.7)', // Roxo
        PRODUCED: 'rgba(40, 85, 135, 0.7)', // Verde Água
        HALF_BILLED: 'rgba(128, 0, 128, 0.7)', // Roxo
        BILLED: 'rgba(0, 0, 0, 0.7)', // Verde Água
    };

    const textColor: Record<ServiceOrderStatusEnum, string> = {
        ERROR: '#212121',
        INITIAL: '#FFFFFF',
        PROCESSING: '#FFFFFF',
        ON_GOING: '#FFFFFF',
        PRODUCTION: '#FFFFFF',
        DELAYED: '#FFFFFF',
        PRODUCED: '#FFFFFF',
        HALF_BILLED: '#FFFFFF',
        BILLED: '#FFFFFF'
    };

    return {
        bgColor: bgColor[status] || 'rgba(0,0,0,0.5)',
        textColor: textColor[status] || '#FFFFFF'
    };
};
